import { ApiContact } from '@Model';
import { Column } from '@synqo/frontend-component-library';

export const contactColumns: Column<ApiContact>[] = [
    { name: 'first_name', label: 'Vorname' },
    { name: 'last_name', label: 'Nachname' },
    { name: 'phone1', label: 'Telefon' },
    { name: 'mobile', label: 'Mobil' },
    { name: 'email', label: 'Email' },
];
